// extracted by mini-css-extract-plugin
module.exports = {"link":"link_button-module--link--3xt3D","linkButton":"link_button-module--link-button--1E5js","lgSize":"link_button-module--lgSize--3B5Ba"};